import { TOGGLE_DROPDOWN, CLOSE_DROPDOWN } from './types'

export default {
  [TOGGLE_DROPDOWN](state, dropdown) {
    state[dropdown].expanded = !state[dropdown].expanded
  },

  [CLOSE_DROPDOWN](state, dropdown) {
    state[dropdown].expanded = false
  },
}
